import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import { IoCheckmarkCircle } from 'react-icons/io5'
import { stMob } from './styles'
import { LuCircle } from 'react-icons/lu'

export default function CompEsporte({ categoria, selected, onClick }) {
  return (
    <Button style={selected ? stMob.containEsportSelect : stMob.containEsportDefault} onClick={onClick}>
      <img src={`${categoria.urlFoto}${categoria.foto}`} alt={categoria.descricao} className={'img-categoria-esporte'} style={stMob.imgEsport} />
      <Box sx={stMob.containTextEsport}>
        <Typography variant='body1' style={stMob.textEsport}>
          {categoria.descricao}
        </Typography>
      </Box>
      {selected ? <IoCheckmarkCircle style={stMob.iconSelected} /> : <LuCircle style={stMob.iconUnselected} />}
    </Button>
  )
}
